module.exports = __webpack_public_path__ + "images/graphic-header-mobile-3_fd2dcd60fa7c75aa65a0501a997956c6.png";